import { Type_RefFuncKrpano } from '@components/Krpano/types';
import { useEventKrpano } from '@containers/Home/hook/useEventKrpano';
import React, { memo, useEffect, useRef } from 'react';
import { useTourEventState } from '../global/TourStats';
import { useKrpano } from '../hook/useKrpano';

interface Props {
  onNextScene: () => void;
  krpanoRef: Type_RefFuncKrpano | null;
}

const TourEvent = memo(({ onNextScene, krpanoRef }: Props) => {
  const intervalTimeChangeScene = useRef<any>(null!);
  const [tourEventStats] = useTourEventState('state');

  const {
    timeChangeScene,
    isAutoChangeScene,
    // enableAutoChangeScene,
    //
    isTurnOnAutoRotate,
    enabledAutoRotate,
    //
    timePauseChangeScene,
    setTimePauseChangeScene,
    //
    // isTemporaryPauseAutoChangeScene,
    // setIsTemporaryPauseAutoChangeScene,
    //
    // onEventAutoChangeScene,
    // offEventAutoChangeScene,
    //
    onEventMoveByKeyCode,
    offEventMoveByKeyCode,
    //
    onEventCheckGyroscopeAvailable,
  } = useEventKrpano({ krpanoRef });

  const { onStartRotate } = useKrpano({ krpanoRef });

  useEffect(() => {
    setTimePauseChangeScene(timeChangeScene);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeChangeScene]);

  /**
   * NOTE: auto rotate (only when isLoaded)
   */
  useEffect(() => {
    if (enabledAutoRotate && isTurnOnAutoRotate && tourEventStats.isLoaded)
      onStartRotate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabledAutoRotate, tourEventStats.isLoaded, isTurnOnAutoRotate]);

  /**
   * NOTE: event autochangescene
   */
  useEffect(() => {
    if (
      !tourEventStats?.isVisibleDollhouse &&
      tourEventStats.isLoaded &&
      isAutoChangeScene &&
      timeChangeScene
    ) {
      intervalTimeChangeScene.current = setInterval(
        () => {
          onNextScene();
          setTimePauseChangeScene(timeChangeScene);
        },
        (timePauseChangeScene || timeChangeScene) * 1000,
      );
      // if (isTemporaryPauseAutoChangeScene)
      //   setIsTemporaryPauseAutoChangeScene(false);
    }
    return () => {
      if (intervalTimeChangeScene.current)
        clearInterval(intervalTimeChangeScene.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isAutoChangeScene,
    tourEventStats.isLoaded,
    // isTemporaryPauseAutoChangeScene,
    tourEventStats.isVisibleDollhouse,
  ]);

  // /**
  //  * NOTE: add event remove autochangescene
  //  */
  // useEffect(() => {
  //   if (
  //     enableAutoChangeScene &&
  //     isAutoChangeScene &&
  //     !tourEventStats?.isVisibleDollhouse
  //   )
  //     onEventAutoChangeScene();
  //   return () => {
  //     if (!isAutoChangeScene) offEventAutoChangeScene();
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   isAutoChangeScene,
  //   enableAutoChangeScene,
  //   tourEventStats?.isVisibleDollhouse,
  // ]);

  useEffect(() => {
    onEventMoveByKeyCode();
    return () => {
      offEventMoveByKeyCode();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    tourEventStats.isLoaded && onEventCheckGyroscopeAvailable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourEventStats.isLoaded]);

  return <div />;
});

export default TourEvent;
